/* eslint-disable no-unreachable, no-debugger */
import { getAppState } from '../../../redux/store';
import {
  selectCalculatedBaseRoomId,
  selectCalculatedRoomId,
  selectGroupPropJsonData,
  selectIndividualProjectData,
  selectMetadataSettings,
  selectProjectJsonData,
  selectRoomData,
  selectUnityData,
} from '../../../redux/slicers/admin/curatorSlicer';
import {
  ENVIRONMENT_LIGHT,
  selectEnvironmentColor,
  selectEnvironmentColorIntensity,
  selectEnvironmentLightType,
  selectHDRIIntensity,
  selectHDRIRotation,
  selectJsonDefaultEnvironmentLightData,
  selectSelectedHDRI,
  selectHDRIIntensityChange,
  selectHDRIChange,
  selectHDRIRotationChange,
  selectIsAO,
} from '../../../redux/slicers/admin/curatorLightSlicer';
import { selectProjectCameraList } from '../../../redux/slicers/camera/projectCameraAngleSlicer';
import {
  selectCanvasFrameHeight,
  selectCanvasFrameWidth,
} from '../../../redux/slicers/camera/cameraSettings';
import { getTexture } from '../../../helpers/idb';
import { CHANGED_MAP_PATHS__TEXTURE_MAP } from '../../../config/constant/unityConstants';
//import { captureException } from '@sentry/react';
import {
  GetRetailConfiguratorRoomInfo,
  GetRoomInfo,
} from '../../../components/container/unityContainer';
import { getCurrentUserUserId } from '../../../contexts/UserContext';
import { UnityEvent, waitForEventOnce } from '../../../helpers/unityPubSub';
import { errorToast } from '../../../helpers/toastHelper';
import { LogCurator } from '../../../helpers/logEvents';


export const getGetRetailConfiguratorRoomInfoJsonFile = async ({ rawOnly } = {}) => {
  const roomJson = await waitForEventOnce(UnityEvent.GetRoomInfo, () => {
    GetRetailConfiguratorRoomInfo();
  });

  if (rawOnly) {
    return roomJson;
  }

  const json_data = JSON.stringify(roomJson);

  const blob = new Blob([json_data], { type: 'application/json' });
  return {
    blob,
    json: json_data,
    raw: roomJson,
  };
};

export const getGroupPropJsonFile = async ({ rawOnly } = {}) => {
  const groupPropInfo = selectGroupPropJsonData(getAppState());

  if (rawOnly) {
    return groupPropInfo;
  }

  const json_data = JSON.stringify(groupPropInfo);

  const blob = new Blob([json_data], { type: 'application/json' });
  return {
    blob,
    json: json_data,
    raw: groupPropInfo,
  };
};

export const getRoomJsonFile = async ({ showError = true, rawOnly } = {}) => {
  const state = getAppState();
  const jsonDefaultEnvironmentLightData = selectJsonDefaultEnvironmentLightData(state);

  const roomInfo = await getRoomInfo('normal');
  if (!roomInfo) {
    if (showError)
      errorToast('Please try again later or connect with your admin.', 'Error LF_3243');
    return roomInfo;
  }

  // remove generated ids required only for old zip files
  roomInfo.materialDetails = roomInfo.materialDetails.map((md) => {
    delete md.objectUniqueIdentifier;
    // remove blob file paths
    md.loadedMaterialPath = '';
    Object.values(CHANGED_MAP_PATHS__TEXTURE_MAP).forEach((key) => {
      md[key] = '';
    });
    return md;
  });

  // add selected environment light
  const lightType = selectEnvironmentLightType(state);
  const hdri = selectSelectedHDRI(state);
  const hdrId = hdri?.id;
  const hdriName = hdri?.name;
  roomInfo.SelectedEnvironmentLight = {
    isAO: selectIsAO(state),
    color: {
      isEnvironmentColorEnabled: lightType === ENVIRONMENT_LIGHT.COLOR,
      actualIntensity: selectEnvironmentColorIntensity(state),
      environmentColor: selectEnvironmentColor(state),
      environmentIntensity: jsonDefaultEnvironmentLightData?.color?.environmentIntensity || 1.2,
    },
    hdri: {
      ishdriEnabled: lightType === ENVIRONMENT_LIGHT.HDRI,
      hdriRotation: selectHDRIRotation(state),
      hdriIntensity: selectHDRIIntensity(state),
      hdriId: `${hdrId}`.toUpperCase() !== 'DEFAULT' ? hdrId : null,
      hdriName,
      isIntensityChanged: selectHDRIIntensityChange(state),
      isRotationChanged: selectHDRIRotationChange(state),
      isHDRIChanged: selectHDRIChange(state),
    },
  };

  // check if env light was changed

  roomInfo.environmentLightWasChanged = wasEnvironmentLightChanged(
    roomInfo.SelectedEnvironmentLight,
    jsonDefaultEnvironmentLightData
  );

  // save cameras in project json
  roomInfo.cameraList = selectProjectCameraList(getAppState()) || [];

  roomInfo.roomId = selectCalculatedRoomId(getAppState());
  roomInfo.baseRoomId = selectCalculatedBaseRoomId(getAppState());

  // update culp json data
  roomInfo.culpSkuUsedData = await parseCulpSkuData(
    roomInfo.culpSkuUsedData,
    roomInfo.roomMetadata
  );

  // screen data
  const canvasWidth = selectCanvasFrameWidth(getAppState());
  const canvasHeight = selectCanvasFrameHeight(getAppState());
  roomInfo.screenWidth = canvasWidth;
  roomInfo.screenHeight = canvasHeight;
  roomInfo.cameraAspect = canvasWidth / canvasHeight;

  // user info
  roomInfo.infoData = {
    userId: getCurrentUserUserId(),
  };

  roomInfo.hasNewLightInfo = true;

  // datetime
  roomInfo.datetime = new Date().toISOString();
  console.log('SAVE_PROJECT_FLOW JSON', roomInfo);

  const roomData = selectRoomData(getAppState());
  const individualProjectData = selectIndividualProjectData(getAppState());
  const initialProjectJson = selectProjectJsonData(getAppState());

  const unityData = selectUnityData(getAppState());
  if (unityData?.isRetailAutomationEditInCurator) {
    roomInfo.isRetailAutomationEditInCurator = true;
  }

  try {
    const activeRoomProjectData =
      (Object.keys(roomData).length && roomData) ||
      (Object.keys(individualProjectData).length && individualProjectData) ||
      (Object.keys(initialProjectJson).length && initialProjectJson);

    if (activeRoomProjectData) {
      // filter options
      roomInfo.filteroptions = activeRoomProjectData.filteroptions;

      // filter options
      roomInfo.room_type =
        'room_type' in activeRoomProjectData
          ? activeRoomProjectData.room_type
          : activeRoomProjectData.project_type;

      // tags
      roomInfo.tags = activeRoomProjectData.tags;
    }
  } catch (error) {
    // captureException(error);
    console.error(error);
  }

  if (rawOnly) {
    return roomInfo;
  }

  const json_data = JSON.stringify(roomInfo);

  const blob = new Blob([json_data], { type: 'application/json' });
  return {
    blob,
    json: json_data,
    raw: roomInfo,
  };
};

window.getGroupPropJsonFile = getGroupPropJsonFile;
window.getRoomJsonFile = getRoomJsonFile;

const getRoomInfo = async (type) => {
  // @type 'normal', 'autosave'
  // this will trigger get info which will be provided in the callback and set later on to localstorage
  // TODO: refactor it to use async/await with unityContext.on -> and wait for GetRoomInfo event triggered
  // GetRoomInfo(type);
  const json = await waitForEventOnce(UnityEvent.GetRoomInfo, () => {
    GetRoomInfo(type);
  });
  LogCurator('DEBUG__getRoomInfo', json);
  // const roomInfo = JSON.parse(localStorage.getItem('roomInfo'));
  // return roomInfo;
  return json || null;
};

const wasEnvironmentLightChanged = (envLight, defaultEnvLight) => {
  try {
    if (!defaultEnvLight) return true;

    if (!envLight.hdri.ishdriEnabled !== defaultEnvLight.hdri.ishdriEnabled) {
      // compare if different was enabled
      return true;
    }

    if (envLight.hdri.ishdriEnabled) {
      return Boolean(envLight.hdri.hdriId);
    }

    if (envLight.color.isEnvironmentColorEnabled) {
      return (
        envLight.color.environmentIntensity !== defaultEnvLight.color.environmentIntensity ||
        envLight.color.environmentColor !== defaultEnvLight.color.environmentColor
      );
    }

    return true;
  } catch (e) {
    //captureException(e);
    console.error(e);
    return false;
  }
};

const parseCulpSkuData = async (culpSkuUsedData, roomMetadataMap) => {
  const result = {};

  try {
    const culpObjectsDatas = Object.values(culpSkuUsedData);
    const roomMetadata = Object.values(roomMetadataMap);
    const metadataSettings = selectMetadataSettings(getAppState());

    await Promise.all(
      roomMetadata.map(async (metadataItem) => {
        if (!metadataItem.status) return;

        const skuItem = culpObjectsDatas.find((item) => item.matName === metadataItem.materialName);
        if (!skuItem) return;

        const skuidToShow = skuItem?.skuId?.trim();

        const jsonObject = {
          objectName: skuItem.objectName,
          matName: skuItem.matName,
          toShowName: metadataItem.objectName,
          skuId: skuidToShow,
          index: skuItem.index,
          repeatL: skuItem.repeatL,
          repeatW: skuItem.repeatW,
          offsetL: skuItem.offsetL,
          offsetW: skuItem.offsetW,
          rotation90Count: skuItem.rotation90Count,
          diffuseId: skuItem.diffuseId,
          diffuseVersion: skuItem.diffuseVersion,
        };

        let textValue = ''; // metadataItem.title + ':         ';

        const data = {
          objectName: {
            value: metadataItem.title,
            key: 'Part Name',
          },
          sku: {
            value: 'SKU - ' + skuidToShow,
            key: 'SKU ID',
          },
          textureName: {
            value: skuItem.textureName,
            key: 'Design',
          },
          content: {
            value: skuItem.content,
            key: 'Content',
          },
          repeat: {
            value: '',
            key: 'Repeat Size',
          },
          offset: {
            value: '',
            key: 'Offset',
          },
          rotation: {
            value: '',
            key: 'Rotation',
          },
        };

        if (skuItem.diffuseId) {
          const textureData = await getTexture(parseInt(skuItem.diffuseId));
          data.content.value = textureData?.description && data.content.value;
          data.textureName.value = textureData?.name || data.textureName.value;
        }

        if (skuItem.rotation90Count > 0) {
          if (skuItem.offsetW != '0.00' || skuItem.offsetL != '0.00') {
            data.repeat.value = '(W) ' + skuItem.repeatW + ' * (L) ' + skuItem.repeatL;
            data.offset.value = '(W) ' + skuItem.offsetW + ' * (L) ' + skuItem.offsetL;
            data.rotation.value = skuItem.rotation90Count * 90 + ' degrees';
          } else {
            data.repeat.value = '(W) ' + skuItem.repeatW + ' * (L) ' + skuItem.repeatL;
            data.rotation.value = skuItem.rotation90Count * 90 + ' degrees';
          }
        } else {
          if (skuItem.offsetW != '0.00' || skuItem.offsetL != '0.00') {
            data.repeat.value = '(W) ' + skuItem.repeatW + ' * (L) ' + skuItem.repeatL;
            data.offset.value = '(W) ' + skuItem.offsetW + ' * (L) ' + skuItem.offsetL;
          } else {
            data.repeat.value = '(W) ' + skuItem.repeatW + ' * (L) ' + skuItem.repeatL;
          }
        }

        const textValueDetails = Object.values(data)
          .map(({ value, key }) => {
            const settings = metadataSettings.find(
              (md) => md.key.toLowerCase() === key.toLowerCase()
            );
            if (!settings) {
              throw new Error('Metadata configuration is incorrect');
            }

            return {
              value,
              enabled: settings.is_render,
              key,
              displayName: settings.display_name,
              label: `${settings.display_name} - ${value}`,
              sequenceNo: settings.seq_no,
            };
          })
          .filter((md) => md.value !== '' && md.value !== null && md.value !== undefined)
          .filter((md) => md.enabled)
          .sort((a, b) => a.sequenceNo - b.sequenceNo);

        const textValueParts = textValueDetails.map((d) => d.label);
        const formattedTextValueDetails = textValueDetails.map(item => ({
          displayName: item.displayName,
          value: item.value,
        }))

        textValue += textValueParts.join(', ');

        jsonObject.textValue = textValue;
        jsonObject.textValueDetails = formattedTextValueDetails;
        result[skuItem.matName] = jsonObject;
      })
    );
  } catch (error) {
    // captureException(error);
    console.error(error);
  }

  return result;
};
